import { combineReducers } from 'redux';
import { coreUsersAllGetAsyncSlice } from './get';
import { updateUsersAllSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const coreUsersAllReducers = combineReducers({
	get: joinReducers(
		[ coreUsersAllGetAsyncSlice.asyncReducers, updateUsersAllSyncSlice.syncReducer ],
		coreUsersAllGetAsyncSlice.asyncState
	)
});

export const coreUsersAllWatchers = combineAllWatchers([
	coreUsersAllGetAsyncSlice.asyncWatchers
]);
